module.exports = __webpack_public_path__ + "img/marketing.e097236f.svg";